
// Route to Module Name mapping
export const routeToModuleMap: Record<string, string> = {
	'/': 'Dashboard',
	'/benefits-verifications': 'Benefits Verification',
	'/profile': 'Profile',
	'/open-invoices': 'Open Invoices',
	'/paid-invoices': 'Paid Invoices',
	'/all-invoices': 'All Invoices',
	'/invoice-cart': 'Invoice Cart',
	'/test': 'Test',
	'/manage-patients': 'Manage Patients',
	'/returns': 'Return Orders',
	'/requests': 'Order Status',
	'/consignments': 'Consignment Orders',
	'/manage-users': 'Manage Users & Roles',
	'/notifications': 'Notifications',
	'/grafts-assign': 'Grafts to Assign',
	'/grafts-confirmed': 'Confirmed Grafts',
	'/audit': 'Audit',
	'/payment-locks': 'Payment Sessions',
	'/billing-tools': 'Billing Tools',
	'/collections': 'Collections',
	'/denial-support': 'Denial Support',
	'/reports/finance': 'Finance Reports',
	'/reports/daily-cash-flow': 'Daily Cash Flow',
	'/documents': 'Documents',
	'/support': 'Support',
	'/app-crash-logs': 'App Crash Logs',
	'/login': 'Authentication',
	'/choose-platform': 'Platform selection',
	'/misbilled-hcpcs': 'Misbilled HCPCS',
	'/misbilled-units': 'Misbilled Units',
	'/unmatched-claims-to-invoices': 'Unmatched Claims To Invoices',
	'/unmatched-invoices-to-claim': 'Unmatched Invoices To Claims',
};